import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type GuideSectionProps = {
  id: string;
  title: string;
  intro?: React.ReactNode;
  children: React.ReactNode;
};
export function GuideSection({
  id,
  title,
  intro,
  children
}: GuideSectionProps) {
  const reduceMotion = useReducedMotion();
  return <section id={id} aria-labelledby={`${id}-t`} className="scroll-mt-20 md:scroll-mt-28 py-7 md:py-20" data-id="element-674" data-mp="vhjafd9tb4on">
      <motion.header className="mb-4 md:mb-12 max-w-3xl" initial={reduceMotion ? false : {
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-10% 0px'
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-675" data-mp="7t9taonjn53u">
        <h2 id={`${id}-t`} className="font-cinzel text-white text-xl sm:text-3xl md:text-[2.5rem] font-bold leading-tight" data-id="element-676" data-mp="bsqxzfv5by7y">
          {title}
        </h2>
        {intro && <div className="mt-1.5 md:mt-4 text-sm md:text-lg leading-snug md:leading-relaxed text-gray-300" data-id="element-677" data-mp="3g89z5rfsp6xh">{intro}</div>}
      </motion.header>
      {children}
    </section>;
}